<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">
    {{
      serviceType && serviceType.ID
        ? serviceType.ServiceTypeDescription
        : ("bikeshop.modal.add_edit_service_types.add_service_type" | translate)
    }}
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
    <span class="hubtiger-close"></span>
  </button>
</div>
<div class="modal-body">
  <div class="row margin-top-8">
    <div class="col-md-6 label">
      {{ "bikeshop.modal.add_edit_service_types.linked_skus_form.enter_sku_or_name" | translate }}
    </div>
    <div class="col-md-6 value">
      <p-autoComplete [(ngModel)]="editLine" field="SKU" [suggestions]="searchResult" placeholder="{{
          'bikeshop.modal.update_job_card.quote.enter_sku_or_name' | translate
        }}" (completeMethod)="searchProducts($event)" (onSelect)="skuSelected($event)">
        <ng-template let-product pTemplate="item">
          <div>
            <span>{{ product.SKU }} - {{ product.Name }}</span>
          </div>
        </ng-template>
      </p-autoComplete>
    </div>
  </div>

  <div class="row margin-top-8">
    <div class="col-md-6 label">
      {{ "bikeshop.modal.add_edit_service_types.service_display_name" | translate }}
    </div>
    <div class="col-md-6 value">
      <input id="float-input" type="text" pInputText placeholder="e.g. Front Suspension" [(ngModel)]="Name" />
    </div>
  </div>

  <div class="row margin-top-8" *ngIf="!isCollections">
    <div class="col-md-6 label">
      {{ "bikeshop.modal.add_edit_service_types.duration" | translate }}
    </div>
    <div class="col-md-6 value">
      <p-dropdown [options]="timeOptions" [(ngModel)]="Duration" optionLabel="showValue" placeholder="e.g. 1h">
      </p-dropdown>
    </div>
  </div>
  <div class="row margin-top-8" *ngIf="isCollections">
    <div class="col-md-6 label">
      {{ "bikeshop.modal.add_edit_service_types.radius" | translate }}
      ({{ partner.DefaultUnitOfMeasure === 1 ? "Km" : "Mi." }})
    </div>
    <div class="col-md-6 value">
      <input id="float-input" type="number" pInputText placeholder="e.g. 2" [(ngModel)]="Radius" />
    </div>
  </div>
  <p *ngIf="errorText" style="margin: 5px 0 0 0; text-align: right; color: #d90028;">
    {{ errorText }}
  </p>
</div>
<div class="modal-footer">
  <div class="row">
    <div class="col-md-4"></div>
    <div class="col-md-4"></div>
    <div class="col-md-4">
      <button [disabled]="busy || (Name === undefined || Duration === undefined || Name.length === 0 || Duration.length === 0)" pButton class="full-width" label="Save" (click)="saveServiceType()"></button>
    </div>
  </div>
</div>